import React, { useEffect, useState } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormLabel } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Controller } from 'react-hook-form';
import { FormSelectIconInputProps } from './FormInputProps';

/**
 * Multi-select checkbox component supporting regular and icon-based options.
 * Stores selected values as array. Supports divider options for grouping.
 */
export const FormInputMultiCheckbox = ({ name, control, label, options, disabled }: FormSelectIconInputProps) => {
  const theme = useTheme();
  const isSelected = (values: any[], optionValue: any) => {
    return values && values.length > 0 && values.indexOf(optionValue) >= 0;
  };

  const handleSelect = (values: any[], optionValue: any) => {
    if (!values) values = [];
    const isPresent = values.indexOf(optionValue);
    if (isPresent !== -1) {
      const remaining = values.filter((item: any) => item !== optionValue);
      return remaining;
    } else {
      return [...values, optionValue];
    }
  };
  return (
    <FormControl>
      {label && <FormLabel component="legend">{label}</FormLabel>}

      <div>
        {options.map((option, index) => {
          if (option.divider) {
            return (
              <FormLabel key={index} component="legend">
                {option.label}
              </FormLabel>
            );
          } else if ('icon' in option) {
            return (
              <Controller
                name={name}
                render={({ field: { value, onChange } }) => {
                  return (
                    <Checkbox
                      color="primary"
                      checked={isSelected(value, option.value)}
                      onChange={() => onChange(handleSelect(value, option.value))}
                      disabled={disabled}
                      icon={option.icon}
                      checkedIcon={option.checkedIcon}
                      sx={{
                        color: theme.palette.primary.main,
                        '&.Mui-checked': {
                          color: theme.palette.primary.main,
                        },
                      }}
                    />
                  );
                }}
                control={control}
              />
            );
          } else {
            return (
              <FormControlLabel
                key={index}
                control={
                  <Controller
                    name={name}
                    render={({ field: { value, onChange } }) => {
                      return (
                        <Checkbox
                          color="primary"
                          checked={isSelected(value, option.value)}
                          onChange={() => onChange(handleSelect(value, option.value))}
                          disabled={disabled}
                          sx={{
                            color: theme.palette.primary.main,
                            '&.Mui-checked': {
                              color: theme.palette.primary.main,
                            },
                          }}
                        />
                      );
                    }}
                    control={control}
                  />
                }
                label={option.label}
              />
            );
          }
        })}
      </div>
    </FormControl>
  );
};
